<!--
 * @Description: 站点质量参数审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-30 15:39:50
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div>
              <div style="padding:20px 0">
                <span>站点：</span><span>{{station}}</span>
                <span style="padding-left:100px">物料：</span><span>{{name}}</span>
                <span style="padding-left:100px">规格：</span><span>{{specification}}</span>
              </div>
                <div style="position: relative;">
                    <div class="params_template">
                        <Template1 v-if="templateIndex === '1'" ref="template1" :readOnly="true" :templateData="templateData"/>
                        <Template2 v-if="templateIndex === '2'" ref="template2" :readOnly="true" :templateData="templateData"/>
                        <Template3 v-if="templateIndex === '3'" ref="template3" :readOnly="true" :templateData="templateData"/>
                        <Template4 v-if="templateIndex === '4'" ref="template4" :readOnly="true" :templateData="templateData"/>
                        <Template5 v-if="templateIndex === '5'" ref="template5" :readOnly="true" :templateData="templateData"/>
                        <Template6 v-if="templateIndex === '6'" ref="template6" :readOnly="true" :templateData="templateData"/>
                        <Template7 v-if="templateIndex === '7'" ref="template7" :readOnly="true" :templateData="templateData"/>
                        <Template8 v-if="templateIndex === '8'" ref="template8" :readOnly="true" :templateData="templateData"/>
                        <Template9 v-if="templateIndex === '9'" ref="template9" :readOnly="true" :templateData="templateData"/>
                        <Template10 v-if="templateIndex === '10'" ref="template10" :readOnly="true" :templateData="templateData"/>
                    </div>
                </div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { saveOrUpdate2 } from "@/api/qualityTemplate";
import Template1 from '../components/Raw/QualityTemplate/Template1'
import Template2 from '../components/Raw/QualityTemplate/Template2'
import Template3 from '../components/Raw/QualityTemplate/Template3'
import Template4 from '../components/Raw/QualityTemplate/Template4'
import Template5 from '../components/Raw/QualityTemplate/Template5'
import Template6 from '../components/Raw/QualityTemplate/Template6'
import Template7 from '../components/Raw/QualityTemplate/Template7'
import Template8 from '../components/Raw/QualityTemplate/Template8'
import Template9 from '../components/Raw/QualityTemplate/Template9'
import Template10 from '../components/Raw/QualityTemplate/Template10'
export default {
  components: {
    FlowContent,
    FlowHeader,
    Template1,
    Template2,
    Template3,
    Template4,
    Template5,
    Template6,
    Template7,
    Template8,
    Template9,
    Template10,
  },
  data() {
    return {
      type: 0,
      title: '站点质量参数审批',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      titlestatus: null,
      station: '',
      name: '',
      specification: '',
      readOnly: false,
      templateIndex: '',
      templateData: {},
      config: null,
      saveStr: ''
    }
  },
  methods: {
    handleBusiness() {
      const params = {
        process_success: {
          url: '/icps/system/sign/basics/qualityDetection/saveStationNormByDetection',
          data: [],
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    handleFinish(type, status) {
      console.log('handleFinish',type, status)
      if (status*1 === 2) {
        // // 审批结束
        const params = {
            ...this.config,
            tableSetting: this.saveStr
        }
        saveOrUpdate2(params)
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: query.isNormal? 'sign_Sitequality2': 'sign_Sitequality',
        dataContent: JSON.stringify(this.$route.query), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type)
  },
  async mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      console.log(query.isNormal)
      // 如果站点质量参数更为宽松，就走严格审批，isMormal是false，，，，，sign_Sitequality2的编码需要创建
      this.$refs.flowcontent.initBaseData(query.isNormal? 'sign_Sitequality2': 'sign_Sitequality');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.config = JSON.parse(query.config)
      this.applyPerson = await getUserInfo().userRealName;
      this.station = this.config.station
      this.specification = this.config.specification
      this.name = this.config.name
      this.templateIndex = query.templateIndex;
      this.templateData = JSON.parse(query.templateData).myData;
      return
    }
    // 审批流程
    const dataContent = JSON.parse(query.dataContent);
    this.config = JSON.parse(dataContent.config)
    console.log(this.config)
    this.station = this.config.station
    this.specification = this.config.specification
    this.name = this.config.name
    this.templateIndex = dataContent.templateIndex;
    this.templateData = JSON.parse(dataContent.templateData).myData;
    this.saveStr = dataContent.templateData
    console.log(123, JSON.parse(dataContent.templateData))

    this.title = query.taskName;
    this.billCode = query.receiptNumber;
    this.applyPerson = query.createUserName;
    this.billDate = query.createTime;
    this.taskStatus = query.taskStatus;
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.wrap {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
</style>